import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
Vue.config.devtools = true
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  state: {
    clientWidth: 0,
    clientHeight: 0,
    projectId: 1, // 登录成功默认为 1
    projectName: '', // 登录成功默认为 1
    projectObj: {},
    corpInfo: {}, // 公司相关展示信息
    userInfo: { // 用户信息
      avatarPath: 'https://account.glodon.com/avatar/show/6540038920208999008/120',
      corpAdmin: 0,
      platformAdmin: true, // 是否为平台管理员
      corpId: 3,
      createAt: 1560217964000,
      email: '2222225@444.com',
      expireTime: null,
      expireTimeStr: null,
      expireTimeType: null,
      globalId: '6540038920208999008',
      glodonId: '6540038920208999008',
      id: 307,
      isDelete: false,
      isInit: false,
      lastExitTime: '2020-02-28 21:06:23.0',
      lastLoginTime: '2020-03-04 16:21:41.0',
      mobile: '',
      nickname: '极膜',
      openId: null,
      organizationId: null,
      password: '0af46a3c5979a9327adefb0f4437fb83',
      rotaMember: 0,
      salt: '929bf2b351a1513230f21d9b7fc668b9',
      sort: null,
      type: null,
      updateAt: 1582528451000,
      userType: 2,
      username: 'fcxadmin'
    },
    projectMenu: { // 为了解决与旧项目的jsp页面的残才跳转方式对接
      allMenu: [], // 所有的菜单（后端直接返回的）
      mainMenu: [], // 一级菜单列表，[xx, xx, xx., ...]
      subMenu: [] // 子菜单列表,顺序与mainMenu的顺序对应, [{...}, ...]
    },
    projectHeadInfo: {
      currentModule: 'workbench' // 当前所在模块: 项目看板、gis、bim
    },
    bimModule: { // 设备监控(bim界面)
      currentFuncValue: 'General', // 当前所在功能模块
      currentMarkerType: null, // 0 工艺单元  1 设备  2 监测点  3 工艺单元组   4 摄像头
      currentMarkerId: null, // 当前操作的工艺单元组/工艺单元/设备/监测点/摄像头 id
      currentProcessId: null, // 当前操作的节点或这标签点所属的工艺单元的id(用来获取工艺单元下的设备及设备状态然后在bim上打标签点)
      currentMarkerName: null, // 当前操作的工艺单元组/工艺单元/设备/监测点/摄像头 name
      currentMarkerCode: null, // ... 工艺单元组的编码
      currentMarkerEleId: null, // ... 构件id
      currentMarkerCameraStatus: null, // ... 的视角信息
      currentMarkerPosition: null, // ... 的三维坐标,
      isShowTreeMenu: false, // 仅通过缩略图控制的目录树的显示隐藏
      isShowBimPanel: false, // 是否显示面板（和bim标签点有交互的面板）
      isShowBimFuncBtn: true, // 是否显示bim各模块切换按钮
      selectedMarkerIds: null, // 格式：'[]'  当前操作目录树或者bim标签点时对应的设备id集合(如果操作的是工艺单元则为工艺单元下的所有设备id，若操作的是设备则为改设备的id),目前在设备管理下有用到
      selectedProcessIds: null, // 格式：'[]'  当前操作对象所属的工艺单元id或者该对象下所有的工艺单元id集合(如操作工艺单元组或设备或工艺单元)
      inspection: {
        tabVal: 'actual', // 默认为实际巡检
        currentInspectionPlan: null // 当前巡检计划id
      },
      equipment: {
        currentView: 'general'
      },
      selectedEquInfo: {
        equId: '',
        equName: '',
        eleId: '',
        isBreakdown: '',
        position3d: '',
        camera3d: '',
        mstId: '',
        mstName: ''
      },
      patrolManage: {
        enableRealyTrack: false,
        playPatrolTrack: false
      }
    }
  },
  mutations: {
    setClientWidth (state, val) {
      state.clientWidth = val
    },
    setClientHeight (state, val) {
      state.clientHeight = val
    },
    setProjectId (state, val) {
      sessionStorage.setItem('session_projectId', val)
      state.projectId = val
    },
    setProjectName (state, val) {
      sessionStorage.setItem('session_projectName', val)
      state.projectName = val
    },
    setProjectObj (state, val) {
      sessionStorage.setItem('session_projectName', val.name)
      state.projectObj = val
    },
    setCorpInfo (state, val) {
      state.corpInfo = val
      sessionStorage.setItem('session_loginUrl', val.loginUrl)
    },
    setAllMenu (state, val) {
      sessionStorage.setItem('session_projectMenu', JSON.stringify(val))
      state.projectMenu.allMenu = val
    },
    setSysAdmin (state, val) {
      sessionStorage.setItem('session_isSysAdmin', val)
      localStorage.setItem('session_isSysAdmin', val)
      state.isSysAdmin = val
    },
    setFunctionCode (state, val) {
      sessionStorage.setItem('session_projectFunctionCode', JSON.stringify(val))
      localStorage.setItem('session_projectFunctionCode', JSON.stringify(val))
      state.projectFunctionCode = val
    },
    setUserInfo (state, val) {
      sessionStorage.setItem('session_userInfo', JSON.stringify(val))
      localStorage.setItem('session_userInfo', JSON.stringify(val))
      state.userInfo = val
    },
    setProjectHeadInfoCurrentModule (state, val) {
      state.projectHeadInfo.currentModule = val
    },
    setBimCurrentFuncValue (state, val) {
      state.bimModule.currentFuncValue = val
    },
    setBimCurrentMarkerType (state, val) {
      state.bimModule.currentMarkerType = val
    },
    setBimCurrentProcessId (state, val) {
      state.bimModule.currentProcessId = val
    },
    setIsShowBimPanel (state, val) {
      state.bimModule.isShowBimPanel = val
    },
    setIsShowTreeMenu (state, val) {
      state.bimModule.isShowTreeMenu = val
    },
    setIsShowBimFuncBtn (state, val) {
      state.bimModule.isShowBimFuncBtn = val
    },
    setBimCurrentMarker (state, val) {
      state.bimModule.currentMarkerId = val.id || null
      state.bimModule.currentMarkerName = val.name || null
      state.bimModule.currentMarkerCode = val.code
      state.bimModule.currentMarkerEleId = val.eleId || null
      state.bimModule.currentMarkerCameraStatus = val.cameraStatus || null
      state.bimModule.currentMarkerPosition = val.position || null
      state.bimModule.isShowBimPanel = true // 点击bim标签点或者目录树节点都设置改属性为true
    },
    setBimSelectedMarkerIds (state, val) {
      state.bimModule.selectedMarkerIds = val
    },
    setBimSelectedProcessIds (state, val) {
      state.bimModule.selectedProcessIds = val
    },
    setBimEquipmentCurrentView (state, val) {
      state.bimModule.equipment.currentView = val
    },
    setBimInspectionTabVal (state, val) {
      state.bimModule.inspection.tabVal = val
    },
    setBimCurrentInspectionPlan (state, val) {
      state.bimModule.inspection.currentInspectionPlan = val
    },
    setBimSelectedEquInfo (state, val) {
      let infoObj = {
        equId: '',
        equName: '',
        eleId: '',
        isBreakdown: '',
        position3d: '',
        camera3d: '',
        mstId: '',
        mstName: ''
      }
      state.bimModule.selectedEquInfo = val || infoObj
    },
    setBimEnableRealyTrac (state, val) {
      state.bimModule.patrolManage.enableRealyTrack = val
    },
    setBimPlayPatrolTrack (state, val) {
      state.bimModule.patrolManage.playPatrolTrack = val
    }
  }
})



// WEBPACK FOOTER //
// ./src/project_web/store/index.js